const STORAGE_PREFIX = 'lidz-pusher-demo-';

export const getDemoChatStorageKey = (pusherIdentification: string): string =>
  `${STORAGE_PREFIX}${pusherIdentification}`;

export const readDemoChatClientId = (pusherIdentification: string): string | null => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(getDemoChatStorageKey(pusherIdentification));
};

export const writeDemoChatClientId = (pusherIdentification: string, clientPhoneIdentifier: string): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(getDemoChatStorageKey(pusherIdentification), clientPhoneIdentifier);
};

export const clearDemoChatClientId = (pusherIdentification: string): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(getDemoChatStorageKey(pusherIdentification));
};
